var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#F25041"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2431 22.256C12.7151 22.256 11.3231 20.944 11.2271 19.072L12.6511 18.976C12.7791 20.368 13.8191 20.912 15.2431 20.912C16.7151 20.912 17.9951 20.368 17.9951 18.832C17.9951 17.328 16.8911 16.64 15.2591 16.64H14.3631V15.296H15.2591C16.6031 15.296 17.5951 14.816 17.5951 13.52C17.5951 12.352 16.8271 11.728 15.3231 11.728C13.8191 11.728 13.0991 12.336 12.9551 13.344L11.5151 13.248C11.7231 11.552 13.0511 10.384 15.3231 10.384C17.6271 10.384 19.0351 11.568 19.0351 13.456C19.0351 14.672 18.3631 15.488 17.0671 15.888C18.5391 16.288 19.4351 17.376 19.4351 18.832C19.4351 21.008 17.7071 22.256 15.2431 22.256Z",
    fill: "#F25041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.b9aaed56a132436ff97507e5b874f20e.svg";
export { ForwardRef as ReactComponent };